import { MapEvent } from './map-event';
import { MapEventType } from './map-event-type';

export class MouseClickMapEvent implements MapEvent {
    type: MapEventType = MapEventType.mouseClick;
    constructor(public payload: mapboxgl.MapMouseEvent) {}
}
